import { create } from "zustand"
import { cloneDeep, findIndex } from "lodash"
import { ApplicationReview } from "../../../_models"
import { isPopulatedArray } from "../../../../../../components/helpers"


interface ApplicationReviewState {
  show_inspect: boolean,  
  show_reassign: boolean,  
  reviewId: number,  
  showInspect: (reviewId: number) => void
  showReassign: (reviewId: number) => void
  clear: () => void
}

export const useApplicationReviewState = create<ApplicationReviewState>()((set) => ({
  show_inspect: false,
  show_reassign: false,
  reviewId: 0,  
  showInspect: (reviewId: number) => set({ show_inspect: true, reviewId}),  
  showReassign: (reviewId: number) => set({ show_reassign: true, reviewId}),  
  clear: () => set({ show_inspect: false, show_reassign: false, reviewId: 0}),
}));

interface ApplicationReviewTableState {
  data : Array<ApplicationReview & {showNotes : boolean}>
  hasNotes: boolean
  showAllNotes: boolean
  setData: (data: Array<ApplicationReview & {showNotes : boolean}>) => void
  toggleNotes: (id: number) => void
  toggleAllNotes: () => void
}

export const useApplicationReviewTableState = create<ApplicationReviewTableState>()((set,get) => ({
  data: [],
  hasNotes: false,
  showAllNotes: true,
  setData: (data: Array<ApplicationReview & {showNotes : boolean}>) => {
    let hasNotes = false;
    
    if (! (isPopulatedArray(data))) {      
      set({data, hasNotes});
      return;
    }

    for(const obj of data) {
      if (obj && (isPopulatedArray(obj?.notes))) {
        hasNotes = true;
        break;
      }
    }

    set({data, hasNotes, showAllNotes: hasNotes});
  },
  toggleNotes: (id: number) => {
    let data = cloneDeep(get().data);

    let _idx = findIndex(data, { id: parseInt(`0${id}`)});
    
    if (! (_idx > -1)) return;

    let row = data[_idx];
    Object.assign(row, { showNotes : row?.showNotes ? false : true});

    data.splice(_idx, 1, row);
    set({data, showAllNotes: false});  
  },

  toggleAllNotes:() => {
    let nextMode = (! get().showAllNotes);
    let data = cloneDeep(get().data).map( o => ({...o, showNotes: nextMode}));
    set({data, showAllNotes: nextMode});
  }

}));